// extracted by mini-css-extract-plugin
export default {"info":"Bunner_info__2i+rZ","infoFadeIn":"Bunner_infoFadeIn__oOm55","info_top":"Bunner_info_top__ETElY","info_title":"Bunner_info_title__ImbvG"};